import {Component, Input} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatRadioModule} from '@angular/material/radio';
import {TranslateWithErrorReportingModule} from '@em/shared/util-configuration';
import {optionValueType} from '@em/data-feed/data-access-products';
import {type ProductGroupFilterDto} from '@em/data-feed/util-types';

//ToDo: to be removed later
@Component({
  selector: 'em-single-filter-row',
  templateUrl: './single-filter-row.component.html',
  styleUrls: ['./single-filter-row.component.scss'],
  standalone: true,
  imports: [
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateWithErrorReportingModule,
    MatRadioModule,
  ],
})
export class SingleFilterRowComponent {
  @Input() filter?: ProductGroupFilterDto;

  constructor() {}

  getFirstOptionValue(): optionValueType | undefined {
    if (this.filter) {
      return Object.values(this.filter.options)[0];
    }
    return undefined;
  }

  getI18nKey(key: string, suffix?: string): string {
    const sfx = suffix?.toUpperCase() ?? '';
    return `CAMPAIGN_PERFORMANCE_FILTER_${key.toUpperCase()}${sfx}`;
  }

  hasOptions(): boolean {
    if (this.filter) {
      return Object.keys(this.filter.options || {}).length > 0;
    }
    return false;
  }
}
